import { Component, ElementRef, EventEmitter, forwardRef, HostListener, OnInit, Output } from '@angular/core';
import { LovDataService } from '../../services/lov-data/lov-data.service';
import { GlobalService } from '../../services/global/global.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-assigning-users-input',
  templateUrl: './assigning-users-input.component.html',
  styleUrls: ['./assigning-users-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssigningUsersInputComponent),
      multi: true
    }
  ]
})
export class AssigningUsersInputComponent implements OnInit, ControlValueAccessor {

  @Output() emitUserDetails: EventEmitter<any> = new EventEmitter();

  allAssigningUsers: any[] = [];
  filterSearchResults: any[] = [];
  selectedCustomerId: any = null;
  searchQuery: string = '';
  isDropdownVisible: boolean = false;

  isDisabled: boolean = false;

  onChange = (value: any) => { };
  onTouched = () => { };

  constructor(private _lovDataService: LovDataService) { }

  ngOnInit() {
  }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();
    if (!this.isDisabled) {
      this.isDropdownVisible = !this.isDropdownVisible;
    }
  }

  filterCountries() {
    const query = this.searchQuery.toLowerCase();
    this.filterSearchResults = this.allAssigningUsers.filter((user: any) =>
      user.userDetail?.firstName?.toLowerCase().includes(query) ||
      user.userDetail?.lastName?.toLowerCase().includes(query) ||
      user.userId?.toLowerCase().includes(query)
    );
  }

  selectUser(user: any) {
    this.selectedCustomerId = user.id;
    this.isDropdownVisible = false;
    this.searchQuery = '';
    this.filterCountries();
    this.emitUserDetails.emit(user);
    this.onChange(this.selectedCustomerId);
    this.onTouched();
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    this.isDropdownVisible = false;
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this._lovDataService.GetAllUsersData().subscribe((response) => {
      this.allAssigningUsers = response;
      this.filterSearchResults = [...this.allAssigningUsers];

      if (value) {
        this.selectedCustomerId = value;
      } else {
        this.selectedCustomerId = null;
      }
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  formatDisplayName(user: any): string {
    return `${user.userDetail?.firstName || ''} ${user.userDetail?.lastName || ''} (${user.userId})`;
  }

  findUserById(userId: string): any {
    const user = this.allAssigningUsers.find((user: any) => user.id === userId);
    if (user) {
      return this.formatDisplayName(user);
    } else {
      return null;
    }
  }
}
